<template>
  <Anicss>
    <Modal @close="close">
      <template #container>
        <div :class="$style.wrapper">
          <div :class="$style.container">
            <img :class="$style.bg" :src="config.bgImg" />
            <component
              :is="exerciseCmpt"
              :history="history"
              :questions.sync="questions"
              read-only
              :class="$style.exercise"
            />
          </div>
        </div>
      </template>
    </Modal>
  </Anicss>
</template>

<script>
import Anicss from '@/components/Anicss'
import Modal from '@/components/Modal'
import exerciseComponents from '@/components/Exercise'
import SvgIcon from '@/components/SvgIcon'
import Button from '@/components/Button'
import { mapState } from 'vuex'

export default {
  components: {
    Anicss,
    Modal,
    SvgIcon,
    Button,
  },
  props: {
    history: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      questions: [],
    }
  },
  computed: {
    exercise () {
      return this.history.type
    },
    exerciseCmpt () {
      return exerciseComponents[this.exercise]
    },
    config () {
      return this.thumbs.find(({ key }) => key == this.exercise)
    },
    ...mapState([
      'thumbs',
    ]),
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply fixed;
  @apply inset-x-0;
  @apply top-0;
  @apply w-box;
  @apply h-box;
  @apply mx-auto;
}

.wrapper {
  @apply h-full;
  box-sizing: border-box;
  padding: 4rem 0;
}

.container {
  @apply h-full;
  @apply w-full;
  @apply relative;
  display: grid;
  padding: 0 4rem;
  box-sizing: border-box;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: "a";
}

.bg {
  @apply object-center;
  @apply object-cover;
  @apply w-full;
  @apply h-full;
  grid-area: a;
}

.exercise {
  grid-area: a;
}
</style>
